import axios from 'axios'
import { Inertia } from '@inertiajs/inertia'

const PING_INTERVAL_MS = 10 * 60 * 1000

function applyCsrfHeader() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    if (meta) {
        axios.defaults.headers.common['X-CSRF-TOKEN'] = meta.getAttribute('content')
    }
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
}

function reloadOnExpiredCsrf() {
    Inertia.on('invalid', (event) => {
        const response = event.detail.response
        if (response && response.status === 419) {
            event.preventDefault()
            window.location.reload()
        }
    })
}

function keepSessionAlive() {
    window.setInterval(() => {
        if (document.hidden) {
            return
        }

        const url = typeof route === 'function' ? route('session.ping') : '/session/ping'
        window.fetch(url, {
            credentials: 'same-origin',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/json',
            },
        }).catch(() => {})
    }, PING_INTERVAL_MS)
}

export function setupCsrfGuards() {
    applyCsrfHeader()
    reloadOnExpiredCsrf()
    keepSessionAlive()
}
